import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ProductsOverviewKpiComponent } from './products-overview-kpi/products-overview-kpi.component';
import { ProductsOverviewTrendComponent } from './products-overview-trend/products-overview-trend.component';
import { IndicatorsSearchToolbarModel } from '../../../models/indicators-search-toolbar-model.model';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { SearchToolbarModelFactoryService } from '../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../models/search-toolbar-factory-parameters.model';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-products-overview',
    templateUrl: './products-overview.component.html',
    styleUrls: ['./products-overview.component.css']
})
// Pagina 35 - Pagina 36
export class ProductsOverviewComponent implements OnInit {
    @ViewChild(ProductsOverviewKpiComponent) productKpi: ProductsOverviewKpiComponent;
    @ViewChild(ProductsOverviewTrendComponent) productTrend: ProductsOverviewTrendComponent;
    public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
    oldData: any;

    items: MenuItem[];
    activeIndex: number;
    translations: any = {};
    alertMsg: string;

    constructor(private translate: TranslateService,
                private svcAnalytics: AnalyticsService,
                private searchModelFactory: SearchToolbarModelFactoryService,
                private confirmationService: ConfirmationService) {

        this.translate.get([
            'products.overview'
        ]).subscribe((t) => {
            this.translations = {
                page_title: t['products.overview']
            };
        });
    }

    ngOnInit() {
        this.activeIndex = 0;
        this.items = [];

        this.translate.get([
            'products.mainKpi',
            'products.Trend',
            'products.alertMsg'
        ]).subscribe(t => {
            const searchParams: SearchToolbarFactoryParameters = new SearchToolbarFactoryParameters();
            searchParams.svcAnalytics = this.svcAnalytics;
            searchParams.dateFunctionType = SearchToolbarDateFunction.VaDates;
            searchParams.finestra = SearchToolbarFilterWindow.ThirtyFive;
            searchParams.raggruppamento = SearchToolbarFilterGrouping.All;
            searchParams.disabledSections = [SearchToolbarSection.CardModes];

            this.searchModelFactory.buildSearchToolbarModel(searchParams).subscribe((model) => {
                this.searchModel = model;
            });

            this.alertMsg = t['products.alertMsg'];

            this.items.push(
                {
                    label: t['products.mainKpi'],
                    command: (event: any) => {
                        this.activeIndex = 0;
                    }
                },
                {
                    label: t['products.Trend'],
                    command: (event: any) => {
                        this.activeIndex = 1;
                    }
                }
            );
        });
    }

    ApplyResult (data) {
        if (!data.product_level || !data.product_code) {
          this.confirmationService.confirm({
            message: this.alertMsg,
            accept: () => false,
            acceptLabel: "Ok",
            rejectVisible: false
          })
          return;
        }
        const isDataEquals = JSON.stringify(this.oldData) === JSON.stringify(data);

        switch (this.activeIndex) {
            case 0:
                if (!isDataEquals) {
                    this.productTrend.resetData();
                }
                this.productKpi.searchValue(data);
                break;
            case 1:
                if (!isDataEquals) {
                    this.productKpi.resetData();
                }

                this.productTrend.searchValue(data);
                break;
        }

        this.oldData = { ...data };
    }



}



// WEBPACK FOOTER //
// ./src/app/views/products/products-overview/products-overview.component.ts